import React from 'react';

import { FormattedMessage } from 'react-intl';

const FulfillmentServiceLabel = () => (
  <FormattedMessage defaultMessage='Service' description='fulfillmentPlanner.fulfillmentService' id='4jqR1h' />
);

export default FulfillmentServiceLabel;
